export default __webpack_public_path__ + "static/Concert-on-Broadway1920px-2f950c049f5b014a4720ca46ecc8ff82.jpg";